import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Popupsolidlist from '../popupsolid/popupsolidlist';
import { addbody, removebody, addtop, removetop, addbottom, removebottom }
    from '../../../../../reduxSlice/coatingpartbSlice/coating2NdSlice';
import FetchApi from '../../../../customhooks/functionFetchApi';
import PopupTemp from '../popupsolid/popupTemp';
import ViewCoatingsystem from '../../../rd/rdcomponent/componentrd/viewCoatingsystem';

const datalist = {
    sequence: "1st", type: "", side: "", color: "", fm: "",
    solid: "",
    dfw_min: "",
    dfw_max: "",
    wfw: "",
    temp: "",
    speed: "",
    rubber: "",
    other: "",
    additive: false,
    additive_name: "",
    additive_fm: "",
    additive_weight: "",
    rfFgbody: "",
    rfFgtop: "",
    rfFgbottom: ""
}

const RdEdit2ndcoating = ({ coating2nd, reloading }) => {
    const FetchApis = new FetchApi();
    const dispatch = useDispatch();

    const [coatingall, setCoatingall] = useState({ ...datalist })
    const [coatingbody, setCoatingbody] = useState({ ...datalist })
    const [coatingtop, setCoatingtop] = useState({ ...datalist })
    const [coatingbotton, setCoatingbotton] = useState({ ...datalist })
    const [notedetail, setNotedetail] = useState("")


    useEffect(() => {
        setNotedetail(coating2nd.otherdetail)
        var databody = {
            sequence: "2nd",
            type: "body",
            side: coating2nd.bodyside,
            color: coating2nd.bodycolor,
            fm: coating2nd.bodyfm,
            solid: coating2nd.bodysolid,
            dfw_min: coating2nd.bodydfw_min,
            dfw_max: coating2nd.bodydfw_max,
            wfw: coating2nd.bodywfw,
            temp: coating2nd.bodytemp,
            speed: coating2nd.bodyspeed,
            rubber: coating2nd.bodyrubber,
            additive: coating2nd.bodyadditive == 1,
            additive_name: coating2nd.bodyadditive_name || "",
            additive_fm: coating2nd.bodyadditive_fm || "",
            additive_weight: coating2nd.bodyadditive_weight || "",
            other: coating2nd.otherdetail
        }
        dispatch(addbody(databody));
        setCoatingbody(databody);

        var datatop = {
            sequence: "2nd",
            type: "top",
            side: coating2nd.topside,
            color: coating2nd.topcolor,
            fm: coating2nd.topfm,
            solid: coating2nd.topsolid,
            dfw_min: coating2nd.topdfw_min,
            dfw_max: coating2nd.topdfw_max,
            wfw: coating2nd.topwfw,
            temp: coating2nd.toptemp,
            speed: coating2nd.topspeed,
            rubber: coating2nd.toprubber,
            additive: coating2nd.topadditive == 1,
            additive_name: coating2nd.topadditive_name || "",
            additive_fm: coating2nd.topadditive_fm || "",
            additive_weight: coating2nd.topadditive_weight || "",
            other: coating2nd.otherdetail
        }
        dispatch(addtop(datatop));
        setCoatingtop(datatop);

        var databottom = {
            sequence: "2nd",
            type: "bottom",
            side: coating2nd.bottomside,
            color: coating2nd.bottomcolor,
            fm: coating2nd.bottomfm,
            solid: coating2nd.bottomsolid,
            dfw_min: coating2nd.bottomdfw_min,
            dfw_max: coating2nd.bottomdfw_max,
            // dfw: coating2nd.bottomdfw,
            wfw: coating2nd.bottomwfw,
            temp: coating2nd.bottomtemp,
            speed: coating2nd.bottomspeed,
            rubber: coating2nd.bottomrubber,
            additive: coating2nd.bottomadditive == 1,
            additive_name: coating2nd.bottomadditive_name || "",
            additive_fm: coating2nd.bottomadditive_fm || "",
            additive_weight: coating2nd.bottomadditive_weight || "",
            other: coating2nd.otherdetail
        }
        dispatch(addbottom(databottom));
        setCoatingbotton(databottom)

    }, [])

    const addcoating = () => {
        if (coatingall.additive && !coatingall.additive_name) {
            Swal.fire({
                title: "กรุณาระบุชื่อ Additive",
                text: "คุณติ๊ก Additive แล้ว กรุณากรอกชื่อ Additive ก่อนเพิ่มข้อมูล",
                icon: "warning",
                confirmButtonText: "ตกลง",
                confirmButtonColor: "#3085d6"
            });
            return;
        }
        if (coatingall.type === 'body' || coatingall.type === 'top' || coatingall.type === 'bottom') {
            if (!coatingall.side || coatingall.side === "") {
                Swal.fire({
                    title: "กรุณาระบุ Side",
                    text: "คุณยังไม่ได้เลือก Side (Internal / External) กรุณาระบุก่อนบันทึก",
                    icon: "warning",
                    confirmButtonText: "ตกลง",
                    confirmButtonColor: "#3085d6"
                });
                return;
            }
        }

        if (coatingall.type == 'body') {
            setCoatingbody(coatingall)
            dispatch(addbody(coatingall))
            UpdateCoating(coatingall, coatingtop, coatingbotton)
        }
        else if (coatingall.type == 'top') {
            setCoatingtop(coatingall)
            dispatch(addtop(coatingall))
            UpdateCoating(coatingbody, coatingall, coatingbotton)

        }
        else if (coatingall.type == 'bottom') {
            setCoatingbotton(coatingall)
            dispatch(addbottom(coatingall))
            UpdateCoating(coatingbody, coatingtop, coatingall)

        }
        else {
            Swal.fire({
                title: "กรุณาเลือกประเภทการบันทึก",
                text: "กรุณาเลือก Body / Top / Bottom ก่อนบันทึกข้อมูล",
                icon: "warning",
                confirmButtonText: "ตกลง",
                confirmButtonColor: "#3085d6"
            });
            return;
        }

    }


    const UpdateCoating = (coatingbody, coatingtop, coatingbotton) => {
        Swal.fire({
            title: "บันทึกเอกสาร",
            text: "คุณแน่ใจที่บันทึกเอกสาร ใช่หรือไม่ ! ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ใช่",
            cancelButtonText: 'ยกเลิก'
        }).then((result) => {
            if (result.isConfirmed) {
                FetchApis.FethcPartbPut(`/technical/updatetechnicalByid/${coating2nd.tecbid}`, coating2nd.tdscode, notedetail, coatingbody, coatingtop, coatingbotton)
                    .then((res) => {
                        if (res.status != 200) {
                            alert(res.message)
                        }
                    })
                reloading()
            }

        })


    }

    const removecoating = () => {

        if (coatingall.type == 'body') {
            setCoatingbody({ ...datalist })

            dispatch(removebody(datalist))

        }
        else if (coatingall.type == 'top') {
            setCoatingtop({ ...datalist })

            dispatch(removetop(datalist))
        }
        else if (coatingall.type == 'bottom') {
            setCoatingbotton({ ...datalist })

            dispatch(removebottom(datalist))
        }
    }

    const onChange_type = (e) => {

        const { name, value } = e.target;
        const ischeck = e.target.checked;

        if (ischeck) {
            if (value == 'body') {

                setCoatingall({ ...coatingbody, type: 'body' })
            } else if (value == 'top') {

                setCoatingall({ ...coatingtop, type: 'top' })

            } else if (value == 'bottom') {
                setCoatingall({ ...coatingbotton, type: 'bottom' })
            }
        }
    }

    const SeelctPropertyList = (fmcode, solid) => {
        setCoatingall({
            ...coatingall,
            fm: fmcode,
            solid: solid
        })
    }

    function selectTemp(valueTemp) {

        setCoatingall({ ...coatingall, temp: valueTemp })
    }

    // แสดงคอลัมน์ Additive ต่อจาก Body / Top / Bottom เฉพาะ type ที่มีการ Add Additive
    const addedCoating = { body: coatingbody, top: coatingtop, bottom: coatingbotton }
    const additiveTypes = ['body', 'top', 'bottom'].filter((type) => addedCoating[type].additive)

    // แบ่งความกว้าง 60% ให้ Body / Top / Bottom และคอลัมน์ Additive (Additive แคบกว่า) ให้ชิดกันพอดี
    const typeWidth = `${60 / (3 + 0.8 * additiveTypes.length)}%`;
    const additiveWidth = `${60 * 0.8 / (3 + 0.8 * additiveTypes.length)}%`;

    function additiveCell(type, field) {
        if (!additiveTypes.includes(type)) return null;
        return <td style={{ width: additiveWidth, backgroundColor: 'rgba(255, 193, 7, 0.08)' }}>{field && addedCoating[type][field]}</td>;
    }

    return (
        <div>
            <div className='end-flex-row ' >
                {/* <Button variant='primary' style={{ fontSize: 12 }} onClick={() => UpdateCoating()}>อัพเดทข้อมูล</Button> */}
            </div>
            <div style={{ width: 700 }} >
                <div className='row-between-page'>
                    <div className='row-between-page' style={{ width: 200, backgroundColor: '#E9E7E2', padding: 5, borderRadius: 4 }}>
                        <div> <input type='radio' name='typecoating' value={'body'}
                            onClick={(e) => onChange_type(e)} /> Body</div>
                        <div><input type='radio' name='typecoating' value={'top'}
                            onClick={(e) => onChange_type(e)} /> Top </div>
                        <div><input type='radio' name='typecoating' value={'bottom'}
                            onClick={(e) => onChange_type(e)} /> Bottom </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 8 }}>
                        <Button size='sm' variant="primary" onClick={() => addcoating()}>เพิ่มข้อมูล</Button>
                        <Button size='sm' variant="warning" onClick={() => removecoating()}>ยกเลิก</Button>
                    </div>

                </div>
            </div>
            <ViewCoatingsystem jourId={coating2nd.journalId} />
            <div style={{ width: 700 }} className='border-green-page'>
                <div className='row-between-page' style={{ width: '100%' }}>
                    <div><b><label>Side</label></b></div>
                    <div className='row-between-page' style={{ width: '25%' }}>
                        <div><input type='checkbox' name='radioside' value={'Internal'} checked={coatingall.side === 'Internal'} onChange={(e) => setCoatingall({ ...coatingall, side: e.target.checked ? 'Internal' : '' })} /> Internal</div>
                        <div><input type='checkbox' name='radioside' value={'External'} checked={coatingall.side === 'External'} onChange={(e) => setCoatingall({ ...coatingall, side: e.target.checked ? 'External' : '' })} /> External</div>
                    </div>
                </div>
                <div className='row-between-page' style={{ width: '100%' }}>
                    <div><b><label>Color shade</label></b></div>
                    <div>
                        <input type='text' name='ColorShade' style={{ width: 200 }} value={coatingall.color}
                            onChange={(e) => setCoatingall({ ...coatingall, color: e.target.value })} />
                    </div>
                </div>
                <div className='row-between-page' style={{ width: '100%' }}>
                    <div><b><label>FM Code</label></b></div>
                    <div className='row-page'>
                        <Popupsolidlist SeelctPropertyList={SeelctPropertyList} />
                        <input type='text' name='FMCode' style={{ width: 200, marginLeft: 5 }} value={coatingall.fm}
                            onChange={(e) => setCoatingall({ ...coatingall, fm: e.target.value })} />
                    </div>
                </div>
                <div className='row-between-page' style={{ width: '100%' }}>
                    <div><b><label>Solid</label></b></div>
                    <div>
                        <input type='number' name='Solid'
                            value={coatingall.solid}
                            style={{ width: 150 }} onChange={(e) => setCoatingall({ ...coatingall, solid: e.target.value })} />
                    </div>
                </div>
                <div className='row-between-page' style={{ width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div><b><label>DFW (gsm) / wfw (Kg /1,000 Sht)</label></b></div>
                    <div style={{ width: 300 }}>
                        <div className='row-between-page'>
                            <label>DFW MIN : </label>
                            <input type='number' name='DFW' style={{ width: 150 }}
                                value={coatingall.dfw_min}
                                onChange={(e) => setCoatingall({ ...coatingall, dfw_min: e.target.value })} />
                        </div>
                        <div className='row-between-page'>
                            <label>DFW MAX : </label>
                            <input type='number' name='DFW' style={{ width: 150 }}
                                value={coatingall.dfw_max}
                                onChange={(e) => setCoatingall({ ...coatingall, dfw_max: e.target.value })} />
                        </div>
                        <div className='row-between-page'>
                            <label>wfw ( kg /1,000 Sht ) : </label>
                            <input type='number' name='wfw'
                                value={coatingall.wfw}
                                style={{ width: 150 }} step='0.01' onChange={(e) => setCoatingall({ ...coatingall, wfw: e.target.value })} />
                        </div>
                    </div>
                </div>

                <div className='row-between-page' style={{ width: '100%' }}>
                    <div><b><label>Temp ( C )</label></b></div>
                    <div className='row-page'>
                        <PopupTemp selectTemp={selectTemp} />
                        <input type='text' name='Temp' style={{ width: 250, marginLeft: 5 }}
                            value={coatingall.temp}
                            onChange={(e) => setCoatingall({ ...coatingall, temp: e.target.value })} />
                    </div>
                </div>

                <div className='row-between-page' style={{ width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div><b><label>Speed (sph)/ No Rubber</label></b></div>
                    <div style={{ width: 300 }}>
                        <div className='row-between-page'>
                            <label>Speed (sph) : </label>
                            <input type='number' name='Speed' style={{ width: 150 }} value={coatingall.speed}
                                onChange={(e) => setCoatingall({ ...coatingall, speed: e.target.value })} />
                        </div>
                        <div className='row-between-page'>
                            <label>No Rubber : </label>
                            <input type='text' name='NoRuble' style={{ width: 150 }} value={coatingall.rubber}
                                onChange={(e) => setCoatingall({ ...coatingall, rubber: e.target.value })}
                            />
                        </div>
                    </div>
                </div>
                <div className='row-between-page' style={{ width: '100%' }}>
                    <div><b><label>Other </label></b></div>
                    <div>
                        <textarea style={{ width: 250, height: 50 }} name='Other' value={notedetail}
                            onChange={(e) => setNotedetail(e.target.value)}>

                        </textarea>
                    </div>
                </div>
                <div className='row-page' style={{ width: '100%', marginTop: 10 }}>
                    <input type='checkbox' name='Additive' id='chkAdditiveEdit2nd'
                        checked={!!coatingall.additive}
                        onChange={(e) => setCoatingall({ ...coatingall, additive: e.target.checked })} />
                    <label htmlFor='chkAdditiveEdit2nd' style={{ marginLeft: 5 }}><b>Additive</b></label>
                </div>
                {coatingall.additive &&
                    <div className='row-between-page' style={{ width: '100%', marginTop: 10, marginBottom: 10 }}>
                        <div><b><label>Additive</label></b></div>
                        <div style={{ width: 350 }}>
                            <div className='row-between-page'>
                                <label>ชื่อ Additive : </label>
                                <input type='text' name='AdditiveName' style={{ width: 200 }}
                                    value={coatingall.additive_name}
                                    onChange={(e) => setCoatingall({ ...coatingall, additive_name: e.target.value })} />
                            </div>
                            <div className='row-between-page'>
                                <label>FM Code : </label>
                                <input type='text' name='AdditiveFM' style={{ width: 200 }}
                                    value={coatingall.additive_fm}
                                    onChange={(e) => setCoatingall({ ...coatingall, additive_fm: e.target.value })} />
                            </div>
                            <div className='row-between-page'>
                                <label>Weight (kg/1000sheets) : </label>
                                <input type='number' name='AdditiveWeight' style={{ width: 200 }} step='0.01'
                                    value={coatingall.additive_weight}
                                    onChange={(e) => setCoatingall({ ...coatingall, additive_weight: e.target.value })} />
                            </div>
                        </div>
                    </div>
                }
            </div>

            <hr></hr>

            <table style={{ width: '100%' }}>
                <tr>
                    <th style={{ width: '10%' }}><center>sequence</center></th>
                    <th style={{ width: '30%' }}><center>Coating system</center></th>
                    <th style={{ width: typeWidth }}><center>Body</center></th>
                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center>Body Additive</center></th>}
                    <th style={{ width: typeWidth }}><center>Top end</center></th>
                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center>Top end Additive</center></th>}
                    <th style={{ width: typeWidth }}><center>Bottom end</center></th>
                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center>Bottom end Additive</center></th>}
                </tr>
                <tr>
                    <td style={{ width: '5%' }}><center><b>2 nd </b></center></td>
                    <td style={{ width: '30%' }}>Side</td>
                    <td style={{ width: typeWidth }}>{coatingbody.side}</td>
                    {additiveCell('body', null)}
                    <td style={{ width: typeWidth }}>{coatingtop.side}</td>
                    {additiveCell('top', null)}
                    <td style={{ width: typeWidth }}>{coatingbotton.side}</td>
                    {additiveCell('bottom', null)}
                </tr>
                <tr>
                    <td style={{ width: '5%' }}></td>
                    <td style={{ width: '30%' }}>Color shade</td>
                    <td style={{ width: typeWidth }}>{coatingbody.color}</td>
                    {additiveCell('body', 'additive_name')}
                    <td style={{ width: typeWidth }}>{coatingtop.color}</td>
                    {additiveCell('top', 'additive_name')}
                    <td style={{ width: typeWidth }}>{coatingbotton.color}</td>
                    {additiveCell('bottom', 'additive_name')}
                </tr>
                <tr>
                    <td style={{ width: '5%' }}></td>
                    <td style={{ width: '30%' }}>FM.code</td>
                    <td style={{ width: typeWidth }}>{coatingbody.fm}</td>
                    {additiveCell('body', 'additive_fm')}
                    <td style={{ width: typeWidth }}>{coatingtop.fm}</td>
                    {additiveCell('top', 'additive_fm')}
                    <td style={{ width: typeWidth }}>{coatingbotton.fm}</td>
                    {additiveCell('bottom', 'additive_fm')}
                </tr>
                <tr>
                    <td style={{ width: '5%' }}></td>
                    <td style={{ width: '30%' }}>DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                    <td style={{ width: typeWidth }}> {coatingbody.dfw_min.length > 0 && <div>{coatingbody.dfw_min}-{coatingbody.dfw_max} / {coatingbody.wfw}</div>}</td>
                    {additiveCell('body', 'additive_weight')}
                    <td style={{ width: typeWidth }}> {coatingtop.dfw_min > 0 && <div>{coatingtop.dfw_min}-{coatingtop.dfw_max} / {coatingtop.wfw}</div>}</td>
                    {additiveCell('top', 'additive_weight')}
                    <td style={{ width: typeWidth }}> {coatingbotton.dfw_min.length > 0 && <div>{coatingbotton.dfw_min}-{coatingbotton.dfw_max} / {coatingbotton.wfw}</div>}</td>
                    {additiveCell('bottom', 'additive_weight')}
                </tr>
                <tr>
                    <td style={{ width: '5%' }}></td>
                    <td style={{ width: '30%' }}>Temp ( C )</td>
                    <td style={{ width: typeWidth }}>{coatingbody.temp}</td>
                    {additiveCell('body', null)}
                    <td style={{ width: typeWidth }}>{coatingtop.temp}</td>
                    {additiveCell('top', null)}
                    <td style={{ width: typeWidth }}>{coatingbotton.temp}</td>
                    {additiveCell('bottom', null)}
                </tr>
                <tr>
                    <td style={{ width: '5%' }}></td>
                    <td style={{ width: '30%' }}>Speed ( sph) / No .Rubber</td>
                    <td style={{ width: typeWidth }}> {coatingbody.speed.length > 0 && <div>{coatingbody.speed} / {coatingbody.rubber}</div>}</td>
                    {additiveCell('body', null)}
                    <td style={{ width: typeWidth }}> {coatingtop.speed.length > 0 && <div>{coatingtop.speed} / {coatingtop.rubber}</div>}</td>
                    {additiveCell('top', null)}
                    <td style={{ width: typeWidth }}> {coatingbotton.speed.length > 0 && <div>{coatingbotton.speed} / {coatingbotton.rubber}</div>}</td>
                    {additiveCell('bottom', null)}
                </tr>
            </table>
            <div>
                <label><b>OTHER DETAIL</b></label>
                <div style={{ marginLeft: '5%', marginTop: 10 }}>
                    {notedetail}
                </div>
            </div>
        </div>
    )
}

export default RdEdit2ndcoating